import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/pages.action';
import * as utility from '../../../utility';
import { Page } from '../../models';

export interface PagesState {
  entities: { [handle: number]: Page };
  loaded: string[];
  loading: string[];
  error?: any;
}

export const initialState: PagesState = {
  entities: {},
  loaded: [],
  loading: [],
};

export const PagesReducer = createReducer(
  initialState,
  on(pageActions.LoadPages, (state: PagesState) => {
    return {
      ...state,
      loading: ['all'],
    };
  }),
  on(pageActions.LoadPagesSuccess, (state: PagesState, { pages }) => {
    const entities = utility.ToEntities(pages, 'handle', state.entities);
    return {
      ...state,
      entities,
      loading: [...state.loading.filter(a => Object.keys(entities).indexOf(a) >= 0)],
      loaded: [...state.loaded, ...Object.keys(entities)],
    };
  }),
  on(pageActions.LoadPagesFail, (state: PagesState, { error }) => {
    return {
      ...state,
      loading: [],
      error,
    };
  }),
  on(pageActions.LoadPageByHandle, (state: PagesState, { handle }) => {
    return {
      ...state,
      loading: [...state.loading, handle],
    };
  }),
  on(pageActions.LoadPageByHandleSuccess, (state: PagesState, { page }) => {
    const entities = { ...state.entities, [page.handle]: page };
    return {
      ...state,
      entities,
      loading: [...state.loading.filter(a => a !== page.handle)],
      loaded: [...state.loaded, page.handle],
    };
  })
);

export const getPagesEntities = (state: PagesState) => state.entities;
export const getPagesLoading = (state: PagesState) => state.loading;
export const getPagesLoaded = (state: PagesState) => state.loaded;
